import { createAction } from 'redux-actions'

export const SET_SOURCES_CATALOG_SETTINGS = 'SET_SOURCES_CATALOG_SETTINGS'
export const setSourcesCatalogSettings = createAction(SET_SOURCES_CATALOG_SETTINGS)



// WEBPACK FOOTER //
// ./actions/sources-catalog.js